export function formatSalaryScale(
	scale: { name: string; startAmount: number; endAmount: number } | null | undefined,
	locale: string,
): string | undefined {
	if (!scale) {
		return undefined;
	}

	const amount = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: 'EUR',
		maximumFractionDigits: 0,
	});

	return `${scale.name} (${amount.format(scale.startAmount)} – ${amount.format(scale.endAmount)})`;
}
